import { render, staticRenderFns } from "./ChartSyncs.vue?vue&type=template&id=529d83b3&scoped=true"
import script from "./ChartSyncs.vue?vue&type=script&lang=js"
export * from "./ChartSyncs.vue?vue&type=script&lang=js"
import style0 from "./ChartSyncs.vue?vue&type=style&index=0&id=529d83b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529d83b3",
  null
  
)

export default component.exports